import { render } from "./VehicleCooperation.vue?vue&type=template&id=0a8cf9bc&scoped=true"
import script from "./VehicleCooperation.vue?vue&type=script&lang=js"
export * from "./VehicleCooperation.vue?vue&type=script&lang=js"

import "./VehicleCooperation.vue?vue&type=style&index=0&id=0a8cf9bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8cf9bc"]])

export default __exports__